module.exports = __webpack_public_path__ + "static/media/email-has-been-confirmed.8e2c54e5.svg";